<template>
  <div class="page" :style="{height:fixedHeight+'px'}">
   <div class="screenLine">
     <el-input  @keyup.enter.native="handelComClick" v-model="keyword" placeholder="名称" style="width: 240px; margin-right: 16px"></el-input>
     <el-select v-model="status" placeholder="广告状态" class="titleSelect" @change="handelComClick">
       <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value" />
     </el-select>
     <el-select v-model="locationParam" placeholder="广告位置" class="titleSelect" @change="handelComClick">
				<el-option v-for="item in locationList" :key="item.item_id" :label="item.item_name" :value="item.item_code" />
			</el-select>
     <el-button type="warning" plain @click="handleResetClick">重置</el-button>
     <el-button type="warning" plain @click="handleUploadClick(1)" class="add">新建</el-button>
    </div>
    <div class="tableBox">
     <el-table :data="tableData" style="width: 100%;height:100%" >
       <el-table-column prop="title" label="广告名称">
       </el-table-column>
       <el-table-column  label="广告位置">
          <template slot-scope="scope">
           {{ scope.row.location_info.name}}
         </template>
       </el-table-column>
       <el-table-column  label="广告周期">
          <template slot-scope="scope">
           {{ $public.FTime(scope.row.begin_time,'YYYY-MM-DD')}}---{{$public.FTime(scope.row.end_time,'YYYY-MM-DD')}}
         </template>
       </el-table-column>
       <el-table-column label="广告状态">
         <template slot-scope="scope">
           <span v-if="scope.row.status == 1">未开始</span>
           <span v-if="scope.row.status == 2">进行中</span>
           <span v-if="scope.row.status == 3">已结束</span>
           <span v-if="scope.row.status == 4">暂停</span>
         </template>
       </el-table-column>
       <el-table-column label="操作" width="200">
         <template slot-scope="scope">
          <el-button  type="text" size="small" @click="handleUploadClick(2,scope.row.id)">编辑</el-button>
						<el-button type="text" size="small" v-if="scope.row.status == 2" @click="handleStopClick(scope.row.id)">暂停</el-button>
						<el-button type="text" size="small" v-if="scope.row.status == 4" @click="handleOpenClick(scope.row.id)">开启</el-button>
						<el-button type="text" size="small" v-if="scope.row.status == 4" @click="handleDeleteClick(scope.row.id)">删除</el-button>
         </template>
       </el-table-column>
     </el-table>
     <page :page="page.page" :total="page.total" @change="changePage" style="margin: 10px 0;"></page>	
   </div>
   </div>
</template>

<script>
import page from "../../../components/page.vue"
export default {
 components: {
     page
   },
    data(){
       return{
         page: {
         page: 1,
         pageSize: 10,
         total: 0
       },
       locationList:[],  //位置列表
				locationParam:'',  //位置
       status:0,
       keyword: "", //关键字
       tableData:[], //商品列表
       sort:'', //排序
       statusList:[{label:'全部',value:0},{label:'未开始',value:1},{label:'进行中',value:2},{label:'已结束',value:3},{label:'暂停中',value:4}],
       fixedHeight: '',
       }
    },
    mounted(){
      this.getTableData()
      this.getLocationData()
     this.fixedHeight = document.documentElement.clientHeight - 106;
    },
    methods:{
      // 确定
     confirmSort(){

      },
    		//删除
			handleDeleteClick(id){
				let params = {
					id:id
				}
				this.$http.delete(process.env.VUE_APP_AppAdmin + '/api/Banner/DeleteBannerRecord', params).then((res)=>{
					if(res.code == 0){
						if (this.title == '') {
							this.$message({
								type: 'success',
								message: '已删除'
							});
							return
						}
						this.getTableData()
					}
				})
			},
			//开启
			handleOpenClick(id){
				let params = {
					id:id
				}
				this.$http.get(process.env.VUE_APP_AppAdmin + '/api/Banner/start', params).then((res)=>{
					if(res.code == 0){
						if (this.title == '') {
							this.$message({
								type: 'success',
								message: '已开启'
							});
							return
						}
						this.getTableData()
					}
				})
			},
			//暂停
			handleStopClick(id){
				let params = {
					id:id
				}
				this.$http.get(process.env.VUE_APP_AppAdmin + '/api/Banner/Stop', params).then((res)=>{
					if(res.code == 0){
						if (this.title == '') {
							this.$message({
								type: 'success',
								message: '已暂停'
							});
							return
						}
						this.getTableData()
					}
				})
			},
      //编辑广告
			handleUploadClick(type,id){
				let query = {}
				if(type == 1){
					query = {
						type:type
					}
				}else{
					query = {
						type:type,
						id:id
					}
				}
				this.$router.push({
					path: 'advertiseEdit',
					query
				})
			},
     getTableData() {
      let params = {
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
        keyword: this.keyword,
        categoryId: this.categoryId,
        status: this.status,
        sort: this.sort,
        locationParam:this.locationParam,
        system:'app',
        desc:true,
      }
      // let loading = this.$loading();
      this.$http.post(process.env.VUE_APP_AppAdmin + '/api/Banner/GetBannerList', params).then((res) => {
        if (res.code == 0) {
          // loading.close();
          console.log(res.data,"广告列表");
          this.tableData = res.data.list;
          this.page.total = res.data.count;

        }
      })
    },
    	//获取位置列表
			getLocationData(){
				let params ={
					code:'Advertising space'
				}
				this.$http.get(process.env.VUE_APP_zichan + '/api/SystemConfig/GetSystemDictionByCode', params).then((res)=>{
					if(res.code == 0){
						console.log(res.data)
						this.locationList = res.data.item_list
					}
				})
			},
     // 搜索
     handelComClick() {
     this.page.page = 1;
     
				this.getTableData()
    },
       //重置
   handleResetClick() {
    this.page.page = 1;
				this.keyword = '';
				this.status = 0;
				this.locationParam = '';
				this.getTableData()
   },
   // 分页方法
     changePage(num) {
       this.page.page = num;
       this.getTableData();
     },
    }
}
</script>

<style lang="scss" scoped>
.page {
 padding: 16px 16px 65px 16px;
 height: 100%;
 box-sizing: border-box;
 position: relative;
 .screenLine {
    display: flex;
    .titleSelect {
      width: 130px;
      margin-right: 16px;
    }
  }
 .tableBox {
    padding: 16px;
    border-radius: 8px;
    background-color: #fff;
    box-sizing: border-box;
    margin-top: 16px;
    height: calc(100% - 56px);
  }
}
</style>